import { PauseCircleOutlined } from '@ant-design/icons';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { isButtonActionExecAsyncService } from './actions/IButtonAction';
import { ButtonWidgetComponent } from './ButtonWidgetComponent';
import {
  ButtonWidgetConfigComponent,
  ButtonWidgetConfigSchema,
} from './ButtonWidgetConfigComponent';
import { createButtonWidgetSchema } from './createButtonWidgetSchema';
import { getButtonWidgetSiblingReferences } from './getButtonWidgetSiblingReferences';
import { IButtonWidget } from './IButtonWidget';

export const ButtonWidgetType: IWidgetType<IButtonWidget> = {
  type: WidgetType.Button,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Pulsante',
  icon: <PauseCircleOutlined />,
  hasValue: false,
  getReference: (path, widget) => {
    // Genero una reference soltanto se il pulsante esegue un servizio asincrono
    if (widget.actions?.filter(isButtonActionExecAsyncService).length) {
      return getSimpleWidgetReference(Datatype.Hidden)(path, widget);
    }
    return null;
  },
  getSiblingReferences: getButtonWidgetSiblingReferences,
  formComponent: ButtonWidgetComponent,
  createFormSchema: createButtonWidgetSchema,
  previewComponent: ButtonWidgetComponent,
  configValidator: ButtonWidgetConfigSchema,
  configComponent: ButtonWidgetConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
  },
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    actions: tran.array(
      tran.object({
        requestMessage: tran.rte(),
        successMessage: tran.rte(),
      }),
    ),
  }),
  rules: [],
};
